import React, { useRef } from 'react';
import isTaxID from 'validator/lib/isTaxID';

function BuscarInput({ titulo, texto, placeholder, tamanhoInput, setErro, setBuscar, termoBusca, setTermoBusca, ApuracaoId }) {

  const erroBusca = ({
    termoInvalido: 'O documento não é válido',
    tamanhoInvalido: `Atenção! O documento precisa ser composto de ${tamanhoInput} números sem caracteres especiais`
  })
  const LOCALE = 'pt-BR';
  const inputBusca = useRef();

  function handleBuscarClique() {
    setErro(null);
    verificarInput(inputBusca, tamanhoInput);
  };

  function handleTeclaEnter(evento) {
    if (evento.key === 'Enter') {
      handleBuscarClique();
    }
  };

  function verificarInput(inputBusca, tamanhoInput) {
    const valorInput = inputBusca.current.value;

    if (!termoDeBuscaPreenchido(inputBusca)) {
      setErro(erroBusca.termoInvalido);
      return;
    };

    if (tamanhoTermoDeBusca(valorInput, tamanhoInput)) {
      setErro(erroBusca.tamanhoInvalido);
      return;
    };

    if (!isTaxID(valorInput, LOCALE)) {
      setErro(erroBusca.termoInvalido);
      return;
    };

    setBuscar(inputBusca, ApuracaoId);
  };

  function termoDeBuscaPreenchido(termoDeBusca) {
    return termoDeBusca?.current?.value;
  };

  function tamanhoTermoDeBusca(termoDeBusca, tamanhoInput) {
    return termoDeBusca?.length !== tamanhoInput;
  };

  function limparCampoBusca(){
    setTermoBusca('');
    setErro(null);
  }

  return (
    <div className='formInline buscaAdmin'>
      <h5>{titulo}</h5>
      <p>{texto}</p>
      <input
        placeholder={placeholder}
        value={termoBusca}
        onChange={(e) => setTermoBusca(e.target.value)}
        ref={inputBusca}
        onKeyDown={handleTeclaEnter} />
      <i onClick={limparCampoBusca} className="fa-solid fa-xmark limpar-input"></i>
      <button className='btn-primario' onClick={handleBuscarClique}>Buscar</button>
    </div>
  );
};

export default BuscarInput;
